import { Input, Table } from "antd"
import { useCallback, useEffect, useState } from "react";
import { Badge, Col, ListGroup, Modal, Row } from "react-bootstrap"
import { ListadoPromocion } from "../../../Service/Service.promocion";
import { ProcedimientosNuevosBilling } from "../../../Service/Service.billing";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { agregarProcedimientos } from "../../../redux/actions";

function ModalPromociones({ data }) {

    const dispatch = useDispatch();

    const { show, handleClose, pacienteSeleccionado, pacienteSelectedDetails } = data;
    const [loading, setLoading] = useState(false);
    const [listarPromociones, setListarPromociones] = useState([]);
    const [selectedPromociones, setSelectedPromociones] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    
    const onRowSelectionChangeNuevo = (selectedRowKeys, selectedRows) => {
        setSelectedPromociones(selectedRows);
    };    
    
    const rowSelectionNuevo = {
        onChange: onRowSelectionChangeNuevo
    };

    const columns = [
        {
            title: 'Promoción',
            dataIndex: 'nombre',
            key: 'nombre',
            width: 300,
        },
        {
            title: 'Seguro/Entidad',
            dataIndex: ['Seguros', 'nombre'],
            key: 'Seguros.nombre',
            width: 200,
        },
    ];
    //alert("aca...");
    const fetchInitialData = useCallback(async () => {
        setLoading(true);
        const promociones = await ListadoPromocion();
        //alert(JSON.stringify(promociones));
        const listado = promociones.data
        .map((item, index) => ({
            ...item,
            key: item.id_promocion,
        }));

        setListarPromociones(listado);
        setLoading(false);
    }, [pacienteSeleccionado]);

    // FUGA-02: faltaba comprobar `show`. Las promociones se pedian aunque el
    // modal estuviera cerrado, cada vez que cambiaba el paciente -- una
    // peticion completa en cada seleccion de paciente, para una lista que
    // quiza nunca se abre. Los otros tres modales de esta pantalla ya lo
    // comprobaban; este se quedo sin ello.
    useEffect(() => {
        if (show) fetchInitialData();
    }, [show, fetchInitialData]);


    const handleAgregarPromociones = async () => {

        if (selectedPromociones.length > 1) {
            Swal.fire({
                icon: "warning",
                title: "Atención",
                text: "Debe seleccionar exactamente una promoción",
            });
            return;
        }

        setLoading(true);
        try {

            const data = {
                paciente_id: pacienteSeleccionado.value,
                procedures: selectedPromociones[0].detalles.map( ex => ({
                    examen_tipo_id: ex.id_tipo_examen,
                    precio: ex.precio_promocion,
                    seguro_id: selectedPromociones[0].seguro_id,
                    factura_promocion: 1
                }))
            }
            //alert("aqui");
            const response = await ProcedimientosNuevosBilling(data);
            //alert(JSON.stringify(response));
            if (!response.success) {
                throw new Error(response.message || "Error al agregar procedimientos");
            }

            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                timer: 1500,
                showConfirmButton: false,
            });
            dispatch(agregarProcedimientos(response.data));

            handleClose();
            
        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al agregar el procedimiento",
            });

        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Agregar Promoci&oacute;n</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <Input
                                placeholder="Buscar por nombre"
                                className="me-2 flex-grow-1"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary mx-1 text-nowrap"
                                disabled={selectedPromociones.length <= 0}
                                onClick={handleAgregarPromociones}
                            >Agregar
                            </button>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <Table loading={loading}
                            columns={columns}
                            size='small'
                            scroll={{ x: "max-content", y: 300 }}
                            pagination={true}
                            rowSelection={rowSelectionNuevo}
                            dataSource={listarPromociones}
                            expandable={{
                                expandedRowRender: (record) => (
                                    record.detalles.length > 0 ? (
                                            <div>
                                                {
                                                    <ListGroup as="ol" numbered>
                                                        {
                                                            record.detalles.map((detalle, index) => (
                                                                <ListGroup.Item
                                                                    as="li"
                                                                    variant="light"
                                                                    className="d-flex justify-content-between align-items-start"
                                                                >
                                                                    <div className="ms-2 me-auto">
                                                                    <div className="fw-bold">{detalle.ExamenTipo.codigo} : {detalle.ExamenTipo.descripcion}</div>
                                                                    P. Normal: ${detalle.tarifario.precio.toFixed(2)}
                                                                    </div>
                                                                    <Badge bg="primary" pill>
                                                                        P. Promoción: ${detalle.precio_promocion.toFixed(2)}
                                                                    </Badge>
                                                                </ListGroup.Item>
                                                            ))
                                                        }
                                                    </ListGroup>
                                                }
                
                                            </div>
                                        ) : (
                                            <p>No hay detalles que mostrar...</p>
                                        )
                                ),
                                rowExpandable: (record) => !!record.detalles,
                            }}                               
                        />
                    </Col>
                </Row>

            </Modal.Body>

        </Modal>
    )

}

export default ModalPromociones